<template>
  <el-upload ref="upload" class="upload-demo" action="#" :show-file-list="false" :auto-upload="false" :on-change="excelUpload">
    <div slot="trigger">
      <el-button type="primary" plain size="mini">
        <svg-icon class="svg-search" icon-class="导入" />
        {{lable}}
      </el-button>
    </div>
  </el-upload>
</template>
<script>
export default {
  props: {
    api:{
        type:String,
        default:''
    },
    lable:{
        type:String,
        default:'导入'
    }

  },
  data() {
    return {

    }
  },
  methods: {
       //导入
    excelUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      const whiteList = ["xls", "xlsx"];
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.messages("上传文件只能是xls、xlsx格式", false, 1000);
        return false;
      }
      let { raw } = file
      let fileData = new FormData() // new formData对象
      fileData.append('multipartFile', raw)
      this.$Import[this.api](fileData).then(({ data }) => {
        if (data.code === 200) {
          this.messages(data.message, true, 1000, () => { })
          this.getInfo()
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.upload-demo {
  margin-right: 10px;
  margin-left: 10px;
  display: inline-block;
}
</style>